/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UpdateComplianceControlRequest extends models.ComplianceControlBase {
    getFixupPrototypeFunction() { return UpdateComplianceControlRequest.fixupPrototype; }

    static newInstance(model: Partial<UpdateComplianceControlRequest>): UpdateComplianceControlRequest {
        let obj = Object.assign(new UpdateComplianceControlRequest(), model);
        UpdateComplianceControlRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UpdateComplianceControlRequest>): UpdateComplianceControlRequest {
        if (!model) return null;
        return UpdateComplianceControlRequest.newInstance(<UpdateComplianceControlRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UpdateComplianceControlRequest) {
        if (!obj) return;

        models.UpdateComplianceControlRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UpdateComplianceControlRequest): boolean {
        if (models.ComplianceControlBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, UpdateComplianceControlRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
